import { render, staticRenderFns } from "./MdCheckBox.vue?vue&type=template&id=9615abc2&"
import script from "./MdCheckBox.vue?vue&type=script&lang=js&"
export * from "./MdCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports